import { connect } from 'react-redux';

import { getDrafts, createDraftOrdersCsv, createDraftOrdersPdf } from '../actions';
import { State } from '../../../reducer';
import { getOrdersSelector } from '../selectors';

import Drafts from '../components/Drafts';

const mapStateToProps = (state: State) => ({
    drafts: getOrdersSelector(state),
});

const mapDispatchToProps = {
    getDrafts,
    createDraftOrdersCsv,
    createDraftOrdersPdf,
};

export default connect(mapStateToProps, mapDispatchToProps)(Drafts);
